/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  window.addEventListener('beforeunload', function (event) {
    history.replaceState({}, document.title, window.location.href);
  });
  
  if (document.documentElement.clientWidth < 641) {
    var lastClicked = null;
    
    var positionCarousel = function(productItem) {
      var scroller = productItem.closest('.scroller__inner');
      scroller.scroll(productItem.clientWidth * Array.prototype.slice.call(productItem.parentElement.children).indexOf(productItem), 0);
    }
    
    var uncollapse = function(e) {
      if (!e.target.closest('.product-list')) {
        return;
      }

      e.preventDefault();
      var blockList = e.target.closest('.product-list');
      var closeButton = e.target.closest('.section[data-section-type="featured-collection"]').querySelector('.block-list__close-button');
      var productItem = e.target.closest('.product-item');
      
      blockList.classList.remove('block-list--collapsed');
      closeButton.classList.add('block-list__close-button--show');
      
      lastClicked = productItem;
      positionCarousel(productItem);
    };
    
    var addListeners = function() {
      document.querySelectorAll('.section[data-section-type="featured-collection"] .product-item__image-wrapper').forEach(function(anchor) {
        anchor.addEventListener('click', uncollapse);
      });

      document.querySelectorAll('.section[data-section-type="featured-collection"] .block-list__close-button').forEach(function(closeButton) {
        closeButton.addEventListener('click', collapse);
      });
    };
    
    var collapse = function(e) {
      e.preventDefault();
      var blockList = e.target.closest('.section[data-section-type="featured-collection"]').querySelector('.product-list');
      var closeButton = e.target;
      
      blockList.classList.add('block-list--collapsed');
      closeButton.classList.remove('block-list__close-button--show');
      positionCarousel(lastClicked);
      addListeners();
    };
    
    addListeners();
  }
})();

if(document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-list-container',
      pagination: '#product-list-pagination',
      loadingText: 'Cargando...',
      callback: function(){
      	document.querySelectorAll('[data-add-to-cart]').forEach(function(element) {
          element.addEventListener('click', window.add_to_cart);
        });
        document.querySelectorAll('.product-item__quantity-selector--action').forEach(function(element) {
          element.addEventListener('click', window.quantityAction);
        });
      }
    });
  });
}

document.querySelectorAll('a[href="/cart"]').forEach( (element) => {
  var url = "".concat(element.href, "?timestamp=").concat(Date.now());
  element.href = url;
});

window.add_to_cart = function(e){
  e.preventDefault();
  var button = e.target.closest('[data-add-to-cart]') || e.target;
  
  if (document.body.classList.contains('template-product') && button.classList.contains('product-form__add-button')){
    var productId = document.getElementsByName('id')[0].value;  
  } else {
    var productId = button.parentNode.previousSibling.value;  
  }

  var sibling = button.nextSibling;

  if(sibling) {
    var inputElement = sibling.querySelector('input');
    addProductToCart(productId, inputElement, true, 1);
    sibling.classList.remove('d-none');
  } else {
    var quantity = document.querySelector('[name="quantity"]');
    addProductToCart(productId, null, true, quantity.value);
  }
};

window.quantityAction = function(e) {
  e.preventDefault();
  e.stopPropagation();
  if (document.body.classList.contains('template-product')) {
    var productId = document.getElementsByName('id')[0].value;
  } else {
    var productId = e.target.parentNode.parentNode.previousSibling.value;
  }
   
  var inputElement = e.target.parentNode.querySelector('input');     
  
  if(e.target.classList.contains('product-item__quantity-selector--minus')) {
    removeProductFromCart(productId, inputElement);
  } else {
    addProductToCart(productId, inputElement, false, 1);
  }
};

document.querySelectorAll('[data-add-to-cart]').forEach(function(element) {
  element.addEventListener('click', window.add_to_cart);
});

// document.addEventListener('doofinder.cart.add', function(event) {
//   const { item_id, amount, title, link } = event.detail;
  
//   var thumbnail = document.querySelector('[dfd-value-link="' + link + '"] .dfd-card-thumbnail img');
//   var src = thumbnail.getAttribute('src');
//   updateCartCount('add');

//   showAddToCartNotification(src, title, amount);
// });

const recentlyViewed = document.querySelector('[data-section-id="static-recently-viewed-products"]');

if (recentlyViewed){
  recentlyViewed.addEventListener('DOMSubtreeModified', recentlyViewedActions, false);
}

function recentlyViewedActions() {
  recentlyViewed.removeEventListener('DOMSubtreeModified', recentlyViewedActions);
  recentlyViewed.querySelectorAll('[data-add-to-cart]').forEach(function(element) {
    element.addEventListener('click', window.add_to_cart);
  });
  
  recentlyViewed.querySelectorAll('.product-item__quantity-selector--action').forEach(function(element) {  
  element.addEventListener('click', function(){
    if (document.body.classList.contains('template-product')) {
      var productId = document.getElementsByName('id')[0].value;
    } else {
      var productId = this.parentNode.parentNode.previousSibling.value;
    }
     
  	var inputElement = this.parentNode.querySelector('input');     
    
    if(this.classList.contains('product-item__quantity-selector--minus')) {
      removeProductFromCart(productId, inputElement);
    } else {
      addProductToCart(productId, inputElement, false, 1);
    }
  });
});
}

document.querySelectorAll('.product-item__quantity-selector--action').forEach(function(element) {  
  element.addEventListener('click', window.quantityAction);
});

window.inputChange = function(e) {
  e.stopPropagation();
  var inputElement = e.target;
  if (document.body.classList.contains('template-product')) {
    var productId = document.getElementsByName('id')[0].value;
  } else {
    var productId = inputElement.parentNode.parentNode.previousSibling.value;
  }
   
  var quantity = inputElement.value;
  var image = inputElement.parentNode.dataset.productImage;
  var title = inputElement.parentNode.dataset.productTitle;
  var oldQuantity = inputElement.dataset.value;

  if(oldQuantity < quantity) {
    addProductToCart(productId, inputElement, true, quantity);
  } else {
    var request = new XMLHttpRequest();
    var data = { quantity: quantity, id: productId };

    var params = Object.keys(data).map(
      function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
    ).join('&');
      
    request.open('POST', '/cart/change.js');
    request.onreadystatechange = function() {
      if(request.readyState == 4 && request.status == 200) {  
        if(quantity <= 0) {
          quantity = 1;
          oldQuantity = 0;
        }
        
        inputElement.value = quantity; 
        inputElement.dataset.value = oldQuantity;
        showAddToCartNotification(image, title, quantity);
        updateCartCount('subtract', 1);
      }
    };
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    request.send(params);
    return request;
  }
}

document.querySelectorAll('.product-item__quantity-selector--input').forEach(function(element) {  
  element.addEventListener('change', function(e){
    window.inputChange(e);
  });
});

document.querySelectorAll('.product-item__quantity-selector--input').forEach(function(element) {
  element.addEventListener('keydown', function(e){
    //e.preventDefault();
    if(e.key == 'Enter') {
      e.preventDefault();   
      let event = new Event('change')
      element.dispatchEvent(event);
    }
  });
});

function addProductToCart(productId, inputElement, firstTime, quantity) {
  var data = { quantity: quantity, id: productId };
  var quantity = quantity;
  var image = '';
  var title = '';
  if(inputElement) {
    quantity = inputElement.value;
    image = inputElement.parentNode.dataset.productImage;
    title = inputElement.parentNode.dataset.productTitle;
  } else {
    var element = document.querySelector('[data-add-to-cart]');
    image = element.parentNode.dataset.productImage;
    title = element.parentNode.dataset.productTitle;
  }
  
  //f (document.body.classList.contains('template-product')) {
    //Revisar campo hidden de variante para ver si cambió la variante y hacer reset del firstTime
    // var variant_changed = document.getElementById('variant-changed').value;
    // if(variant_changed == 1) { 
    //   firstTime = true;
    //   document.getElementById('variant-changed').value = 0;
    // }
  //}
  
  var params = Object.keys(data).map(
    function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
  ).join('&');

  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js');
  xhr.onreadystatechange = function() {
    if(xhr.readyState == 4 && xhr.status == 200)
    {
      if(!firstTime) {
        if(inputElement) {
          quantity++;
          inputElement.value = quantity;
          inputElement.dataset.value = quantity;
        }
        showAddToCartNotification(image, title, quantity);
        updateCartCount('add', 1);
      } else {
        if(inputElement) {
          inputElement.dataset.value = quantity;
        }
      	showAddToCartNotification(image, title, quantity);
        updateCartCount('add', quantity);
      }
      
      
    }
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(params);
  return xhr;
}

function removeProductFromCart(productId, inputElement) {
  var quantity = inputElement.value;
  var image = inputElement.parentNode.dataset.productImage;
  var title = inputElement.parentNode.dataset.productTitle;
  
  var totalQuantity = 0;
  var found = false;

  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/cart.js', true);

  xhr.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      var data = JSON.parse(this.response);
      data.items.forEach(function(item, index) {
        var id = item.variant_id;

        if(id == productId) {
          totalQuantity = item.quantity - 1;
          found = true;
        }
      });

      if (found && totalQuantity > 0) {
        var request = new XMLHttpRequest();
        var data = { quantity: totalQuantity, id: productId };

        var params = Object.keys(data).map(
          function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
        ).join('&');

        request.open('POST', '/cart/change.js');
        request.onreadystatechange = function() {
          if(request.readyState == 4 && request.status == 200)
          {
            quantity--;
      
            if(quantity <= 0) {
              quantity = 1;
            }
            
            inputElement.value = quantity; 
            inputElement.dataset.value = quantity;
            showAddToCartNotification(image, title, quantity);
            updateCartCount('subtract');
          }
        };
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        request.send(params);
        return request;
      }

    } 
  };

  xhr.send();
}

/* Construir el notification */
function showAddToCartNotification(image, title, quantity) {
  var container = document.querySelector('.add-to-cart__notification');
  var text = 'Se ha agregado <strong>(' + quantity + ')</strong> ' + title + ' al carrito';
  var html = '<div class="add-to-cart__notification--container"><img src="' + image + '"><span>' + text + '</span></div>';
  
  container.innerHTML = html;
  
  /* mostrar con timeout o variar el opacity css */
  container.classList.add('show');
  
  setTimeout(function(){
  	container.classList.remove('show');
  },5000);
}

function updateCartCount(action, quantity) {
  var element = document.querySelector('.header__cart-count');
  var value = parseInt(element.textContent);
  
  if(action == 'add') {
    element.textContent = value + parseInt(quantity);
  } else {
    element.textContent = value - parseInt(quantity);
  }
}

/* 
const quantitySelect = document.getElementById('quantitySelect');
const maxQuantity = 10;

function initializeSelector() {
    // Genera las opciones del 1 a maxQuantity
    for (let i = 1; i <= maxQuantity; i++) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = i; // Inicialmente, solo muestra el número
        quantitySelect.appendChild(option);
    }
    
    // Establece el texto inicial para la primera opción
    updateSelectedText();
}

// Función para actualizar el texto de la opción seleccionada
function updateSelectedText() {
    const selectedOption = quantitySelect.options[quantitySelect.selectedIndex];
    
    for (let i = 0; i < quantitySelect.options.length; i++) {
        quantitySelect.options[i].textContent = quantitySelect.options[i].value;
    }
    
    // Añade el prefijo "Cantidad:" solo a la opción seleccionada
    selectedOption.textContent = `Cantidad: ${selectedOption.value}`;
}


document.addEventListener('DOMContentLoaded', initializeSelector);

quantitySelect.addEventListener('change', updateSelectedText);

*/

document.addEventListener('DOMContentLoaded', () => {
  const quantitySelect = document.getElementById('quantity-select');
  const mobileTrigger = document.getElementById('mobile-quantity-trigger');
  const mobileValueDisplay = document.getElementById('mobile-quantity-value');
  const modal = document.getElementById('quantity-modal');
  const modalCloseBtn = document.getElementById('modal-close-btn');
  const optionsList = document.getElementById('quantity-options-list');

  const openModal = () => {
    optionsList.innerHTML = '';
    const currentValue = quantitySelect.value;
    const options = quantitySelect.options;
    
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const listItem = document.createElement('li');
      listItem.textContent = option.textContent;
      listItem.dataset.value = option.value;

      // Si el valor de esta opción es el que está seleccionado,
      // le añadimos la clase para resaltarlo.
      if (option.value === currentValue) {
        listItem.classList.add('opcion-seleccionada');
      }
      
      listItem.addEventListener('click', () => {
        // Al hacer clic en una opción del modal, actualizamos todo
        updateSelection(listItem.dataset.value);
        closeModal();
      });
      optionsList.appendChild(listItem);
    }
    modal.style.display = 'flex';
  };
  
  const closeModal = () => {
    modal.style.display = 'none';
  };

  const updateSelection = (value) => {
    // Actualiza el valor del <select> original
    quantitySelect.value = value;
    // Dispara el evento 'change' para que cualquier otro script reaccione
    quantitySelect.dispatchEvent(new Event('change'));
  };

  if (mobileTrigger) {
    mobileTrigger.addEventListener('click', openModal);
  }

  if(quantitySelect) {
    quantitySelect.addEventListener('change', () => {
      const selectedOption = quantitySelect.options[quantitySelect.selectedIndex];
      mobileValueDisplay.textContent = selectedOption.text;
    });
  }

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closeModal);
  }
  if (modal) {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal();
      }
    });
  }
});
